import Rotate from "components/common/Rotate";
import { isDesktop } from "react-device-detect";
import DeviceOrientation, { Orientation } from "react-screen-orientation";
const DeviceRotate = ({ children }) => {
  if (isDesktop) {
    return children;
  } else {
    return (
      <DeviceOrientation className="fullPage" lockOrientation={"landscape"}>
        <Orientation orientation="landscape" alwaysRender={false}>
          <Rotate />
        </Orientation>
        <Orientation className="fullPage" orientation="portrait">
          {children}
        </Orientation>
      </DeviceOrientation>
    );
  }
};

export default DeviceRotate;
